
import { Component, Vue } from "vue-property-decorator";
import Deferrable from "@/libs/common/delegate/Deferrable";
import Defer from "@/libs/Defer";
import { Duct } from "@/libs/Duct";
import { mapState } from "vuex";
import { Base64 } from "js-base64";
import WorldCupComponent from "@/libs/WorldCupComponent";

@Component({
  components: {},
  computed: {
    ...mapState({
      svgPathRealtimeMap: "svgPathRealtimeMap",
    }),
  },
})
export default class ComponentTest
  extends WorldCupComponent
  implements Deferrable
{
  paths: string;
  defer: Defer;
  svgPathRealtimeMap: {
    paths: string;
  };

  svg: {
    class: string;
    paths: string;
  };

  private isPreloadDone: boolean;
  private isMounted: boolean;

  created(): void {
    this.svg = {
      class: "list-group pt-md-5",
      paths: undefined,
    };

    Duct.open(Duct.Vanes.OnPreloadDone, this.onPreloadDone);

    this.defer = Defer.create().setDeferrable(this);
    this.defer.wait();
  }

  mounted(): void {
    this.isMounted = true;
  }

  onPreloadDone() {
    this.isPreloadDone = true;
  }

  onDefer(defer?: Defer): boolean {
    if (this.isMounted && this.isPreloadDone) {
      return false;
    }
    return true;
  }

  onReady(defer?: Defer) {}
}
